import sanitizeHtml from 'sanitize-html';
import { StyledDescription } from '../styled';

const LEGACY_ALLOWED = { allowedTags: ['strong', 'em', 'b', 'i', 'br'] };
const HTML_ALLOWED = {
  allowedTags: ['p', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li', 'br'],
};

function formatRichtext(text: string): string {
  const withBold = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  const withItalic = withBold.replace(/\*(.+?)\*/g, '<em>$1</em>');
  const withBreaks = withItalic.replace(/\n/g, '<br/>');
  return sanitizeHtml(withBreaks, LEGACY_ALLOWED);
}

function isHtml(description: string): boolean {
  const trimmed = description.trim();
  return trimmed.startsWith('<') && trimmed.includes('>');
}

function toSafeHtml(description: string): string {
  if (isHtml(description)) {
    return sanitizeHtml(description.trim(), HTML_ALLOWED);
  }
  return formatRichtext(description);
}

interface DescriptionProps {
  description: string;
}

export const Description = ({ description }: DescriptionProps) => {
  return (
    <StyledDescription
      component="div"
      dangerouslySetInnerHTML={{ __html: toSafeHtml(description) }}
    />
  );
};
